import Link from 'next/link';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/zh-cn';
import { sify } from 'chinese-conv';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';

dayjs.extend(relativeTime);

const NotifyComponent = ({ locale, notify = {}, t, onClose }) => {
    const { h18Url, forumUrl } = useSelector(urlState);

    // 語言設定
    dayjs.locale(`zh-${locale}`);

    const { sendTime, url = '', site } = notify;

    // 通知時間
    const notifyTime = dayjs(sendTime).fromNow();
    // 標題顯示
    const title = locale === 'cn' ? sify(notify?.title || '') : notify?.title;

    const renderInner = (notify) => {
        return (
            <>
                <p
                    className={`text-bd4n text-black9 [&>span]:text-bou [&>span]:trans [&>span]:group-hover:text-purple ${
                        notify?.url ? 'hover-text group-hover:decoration-black9' : ''
                    }`}
                    dangerouslySetInnerHTML={{ __html: title }}
                />

                <div className="between-center text-bd3n text-black4">
                    <span>{t('SYSTEM')}</span>

                    <span>{notifyTime}</span>
                </div>
            </>
        );
    };

    if (site === 1)
        return (
            <Link
                href={url}
                onClick={onClose}
                className="py-[16px] border-t-1 border-dashed border-black2 space-y-[10px] block group"
            >
                {renderInner(notify)}
            </Link>
        );

    return (
        <a
            href={(site === 18 ? h18Url : site === 2 ? forumUrl : '') + url}
            onClick={onClose}
            target="_blank"
            rel="noreferrer noopener"
            className="py-[16px] border-t-1 border-dashed border-black2 space-y-[10px] block group"
        >
            {renderInner(notify)}
        </a>
    );
};

export default NotifyComponent;
